import React, { useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import ListboxComponent from '../ListboxComponent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import PropTypes from 'prop-types';
import { noop } from '../propTypes';
import FormInput from '../FormInput';
import './styles.scss';

// icon being showed beside auto-complete single row before selection
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// icon being showed beside auto-complete single row after selection
const checkedIcon = <CheckBoxIcon fontSize="small" color="primary" />;
// close icon for the Tag/Chip
const closeRoundedIcon = <ClearRoundedIcon fontSize="small" />;

function TaggedFieldWithAutoComplete({
    options,
    placeholder,
    bootstrapIcon,
    loading,
    title,
    onSelect,
    id,
}) {
    const [showPlaceholder, setShowPlaceholder] = useState(true);
    return (
        <FormInput title={title} bootstrapIcon={bootstrapIcon}>
            <Autocomplete
                multiple
                id={id}
                loading={loading}
                options={options}
                disableCloseOnSelect
                ListboxComponent={ListboxComponent}
                onChange={(event, selected) => {
                    Object.keys(event); //this will give you the selected value dictionary (source)
                    onSelect(selected); //this will give you the selected value dictionary (source)
                    selected.length
                        ? setShowPlaceholder(false)
                        : setShowPlaceholder(true);
                }}
                getOptionLabel={(option) => option.title}
                renderOption={(option, { selected }) => (
                    <>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            className="single-tag"
                            checked={selected}
                        />
                        {option.title}
                    </>
                )}
                renderInput={(params) => {
                    return (
                        <>
                            <TextField
                                variant="outlined"
                                placeholder={
                                    showPlaceholder ? placeholder : null
                                }
                                fullWidth
                                {...params}
                            />
                        </>
                    );
                }}
                ChipProps={{
                    deleteIcon: closeRoundedIcon,
                }}
            />
        </FormInput>
    );
}

TaggedFieldWithAutoComplete.propTypes = {
    options: PropTypes.array,
    placeholder: PropTypes.string,
    bootstrapIcon: PropTypes.string,
    title: PropTypes.string,
    onSelect: PropTypes.func,
    id: PropTypes.string,
    loading: PropTypes.bool,
};

TaggedFieldWithAutoComplete.defaultProps = {
    value: null,
    placeholder: 'Favorites',
    bootstrapIcon: 'icon-flag',
    title: 'Challenges',
    onSelect: noop,
    id: '12',
    loading: false,
};

export default TaggedFieldWithAutoComplete;
